import CheckBox from "./checkBox"
import Group from "./group"

CheckBox.Group = Group
export default CheckBox